import React from 'react';
import { Anchor, Button } from 'grommet';
import { Notes } from 'grommet-icons';
import { formatPhoneNumber } from '@enrich/shared-lib';

export const fullName = (contact) => `${contact.firstName} ${contact.lastName}`;

// Columns for the list page. Contacts are flat (Utils.deepFlatten).
// Only Name sorts, on the server, by last name then first name.
export const contactListColumns = ({ onViewNotes }) => [
    {
        header: 'Name',
        property: 'lastName',
        render: (contact) => (
            <Anchor
                href={`/contacts/${contact.id}`}
                label={fullName(contact)}
            />
        ),
        sortable: true,
    },
    {
        header: 'Email',
        property: 'email',
        sortable: false,
    },
    {
        header: 'Majors',
        property: 'majors',
        render: (contact) => {
            const majors = contact.majors ?? [];
            if (majors.length === 0) return 'N/A';
            return majors.map((major) => major.name).join(', ');
        },
        sortable: false,
    },
    {
        header: 'Location',
        property: 'hometown',
        render: (contact) => contact.hometown || 'N/A',
        sortable: false,
    },
    {
        header: 'Phone',
        property: 'phoneNumber',
        render: (contact) => formatPhoneNumber(contact.phoneNumber) || 'N/A',
        sortable: false,
    },
    {
        header: 'Notes',
        property: 'contact_notes',
        render: (contact) => {
            if (!contact.contact_notes?.count) return 'N/A';
            return (
                <Button
                    a11yTitle={`View notes for ${fullName(contact)}`}
                    icon={<Notes />}
                    onClick={() => onViewNotes(contact)}
                />
            );
        },
        sortable: false,
    },
];
